import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { PaymentMethodsCommandNames, StatusTypes, UserAddressCommandNames } from '@chegg/commerce-utils';
import { ERRORS } from '../../../../constants/Errors';
import { doFireStatusUpdate } from '../../../../utils/CallbackUtils';
import { saveUserAddressCommands } from '../../CommandState.actions';
import { Component } from '../../../../constants/CallbackConstants';
/**
 * returns yiftee mop
 * @param params
 * @returns
 */
export var getYifteeMop = function getYifteeMop(params) {
  var mopOnFile = params.mopOnFile,
    payment = params.payment,
    dispatch = params.dispatch,
    isZipMandatory = params.isZipMandatory;
  var mop = mopOnFile.yifteeMop;
  var billingAddress = payment.billingAddress;
  var zip = billingAddress.zip,
    country = billingAddress.country;
  if (!mop) return null;
  if (!zip && isZipMandatory || !country) {
    dispatch(saveUserAddressCommands([{
      commandName: UserAddressCommandNames.VERIFY_ADDRESS
    }]));
    // return error callback for incomplete form
    doFireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
      payload: {
        component: Component.EXECUTE_COMMAND_LOGIC,
        errors: [ERRORS.MISSING_ADDRESS_INFORMATION]
      }
    }]);
    return null;
  }
  mop = _objectSpread(_objectSpread({}, mop), {}, {
    billingAddress: _objectSpread(_objectSpread(_objectSpread({}, mop.billingAddress), billingAddress), {}, {
      zip: billingAddress.zip
    })
  });
  return mop;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/helpers/getYifteeMop.js
// module id = 4405
// module chunks = 11